import { tagSx } from '@/components/blocks/SameDayTag/styles/sameDayTag';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { mergeSx } from '@/utils/mergeSx';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';
import {
	MATERIAL_SYMBOL_ICONS,
	OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

/** Matches the Body/Baseline 15px label. */
const ICON_SIZE = 15;

type Props = {
	/** Placement only — each surface positions the tag its own way. */
	sx?: SxProps<Theme>;
};

/**
 * "Entrega express" tag for a product resolving Same Day delivery (163024) —
 * shared by the PLP product box (163100) and the PDP express button (163146).
 */
export const SameDayTag: FC<Props> = ({ sx }) => {
	const { Availability } = useLocalization('HDMProductDetail');

	return (
		<Box sx={mergeSx(tagSx, sx)}>
			{/* `BoltIcon` only ships the filled variant, and ignores `size` — hence width/height. */}
			<DynamicIcon
				name={MATERIAL_SYMBOL_ICONS.bolt}
				variant="filled"
				width={ICON_SIZE}
				height={ICON_SIZE}
			/>
			<Typography variant="bodyBaseline" fontWeight={OpenSansFontWeights.semibold} component="span">
				{Availability.labels.homeDeliveryExpress.t()}
			</Typography>
		</Box>
	);
};
